
<script>

    import { getContext, onMount } from 'svelte';
    import { fly } from 'svelte/transition';
    import { navigateTo } from 'svelte-router-spa'

    import { memberStore } from '../../store.js';
    import Header from '../global/header.svelte'
    
    import Dialog from '../widgets/dialog.svelte';
    
    import moment from 'moment';

    let card = '';


	onMount(async () => {
         
         card = document.getElementById("nocard");
         if( localStorage.getItem('number')) {
             card.value = localStorage.getItem('number');
         }
         if( localStorage.getItem('zip') ) {
              zip.value = localStorage.getItem('zip');
         }
   
	});


    let hasAcceptedTC = false;
    let hasAcceptedAgeGate = false;

    function toggleTC() {
      
        if( this.value == 1 ) {
            hasAcceptedTC = "disabled";
        } else {
            hasAcceptedTC = "";
        }
    }

    function toggleAgeGate() {

         if( this.value == 1 ) {
            hasAcceptedAgeGate = "disabled";
        } else {
            hasAcceptedAgeGate = "";
        }

    }

    function doLogin() {


        localStorage.setItem('number', card.value);
        localStorage.setItem('zip',  zip.value);
         
         if( !card.value ) {
             showDialog("", "Please enter your card number and postcode");
         } else {
             
             var formData = new FormData();
             formData.append('number', card.value);
             formData.append('zip', zip.value);


            fetch("https://api.southernco-op.co.uk/member/subscribe", {
                    method: "POST",
                    headers: {
        
                    },
                    body: formData,
                    redirect: 'follow'
                })
                .then( response => {
                    // -- Save our users data to the store

                    return response.json();

                   
                }).then( data => {

                    console.log( data.error );

                    if( data.error ) {

                        showDialog("Error", "" );
                        return false;

                    } else {


                        memberStore.set({
                            "name":data.name,
                            "points":data.points,
                            "number":data.membership_number,
                            "last_update": moment(new Date()).format("DD/MM/YYYY")
                        });
                        // Do something here

                    
                        dataLayer.push({
                            'event':'CustomEvent',
                            'category':'Log In',
                            'action':'Log in success',
                            'label':'Form submission'
                        });
                    
                    
                    navigateTo('/') 

                    }
                   

                })                
                .catch( err => {

                    showDialog();

                });
         }

    };


    /* ===== Dialog Handler */ 
    const { open } = getContext('simple-modal');

    const onCancel = (text) => {
		name = '';
		status = -1;
	}
	
	const onOkay = (text) => {
		name = text;
		status = 1;
	}

    const showDialog = (title, message) => {

        if( !title ) title="Login Error";
        if( !message) message="We're having problems matching your credentials please check you have entered the correct number excluding the 633174. If problems persist please email membersupport@southerncoops.co.uk";

		open(
			Dialog,
			{
                title: title,
				message: message,
                hasForm: true,
                onCancel,
				onOkay
			},
			{
				closeButton: false,
                closeOnEsc: false,
                closeOnOuterClick: false,
			}
	  );
    };
    
    

    function showTerms() {
     
        localStorage.setItem('number', card.value);
        localStorage.setItem('zip',  zip.value);

    }

     


</script>

<style>

h1 {
    
    font-size: 25px;
    font-size: 2.5rem;
    font-weight: 300;
    margin-bottom: 0;
}

form {
    border: 1px solid #fff;
    border-radius: 5px;
    margin: 2em 0;
}

form div div {
   
}

form .form__section-split {
    display: flex;
}

form .form__section {
    display: flex;
    align-items: center;
}

form .form__section:not(:last-of-type) {
    border-bottom: 1px solid #fff;
}

.card-number-prefix {
    flex: 1 1 100px;
    border-right: 1px solid #fff;
     padding: 1em;
     text-align: center;
}

.card-number-input {
    flex: 1 1 100%;
    
     display: flex;
     align-items: center;
}

.card-number-input  input[type="text"] {
    background: none;
    border: none;
    display: block;
    margin: 0;
    width: 100%;
    padding: 0;
     padding: 1em;
     font-family: proxima-nova, sans-serif;
}



form button {
    background: #fff;
    border-radius: 20px;
    width: 80px;
    color: #00627d;
    border: none;
}

button {
    background: #fff;
    font-size: 130%;
}

.login-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

}

.login-head  img {
    width: 30vw;
    max-width: 200px;

}

 .logo {
     position: absolute;
     top: 10%;
     left: 5%;
        max-width: 45%;
    }
    .form-elm {
        padding: 1em;
    }
    
    small {
        line-height: 1.1
    }
.contact {
    color: var( --brand-color );
}

button:disabled {
    opacity: .5
}

.terms {
    text-decoration: underline
}

.form-elm--cb input {
    display: inline;
}

</style>

<Header title="" url="" /> 
<section>
    <div>
        <div class="login-head">
            <h1>Your account</h1>
           
                <img src="card/card-small.png" alt="Coop Card" />
           
        </div>
        <p>Please enter your membership number below. This can be found on your membership card or your 'Welcome to membership' email.</p>
        <form>
            <div class="form__section form__section-split">
                <!-- <div class="card-number-prefix">633174</div> -->
                <div class="card-number-input"><input type="text" name="_card" value="" id="nocard" pattern="[0-9]*" placeholder="Enter your card number" /></div>
            </div> 
            <div class="form__section">
                <div class="card-number-input"><input type="text" name="_zip" value="" id="zip" placeholder="Enter your postcode" /></div>
            </div>
             <div class="form__section">
                <div class="form-elm form-elm--cb" >
                    <input bind:checked={hasAcceptedAgeGate} type="checkbox" id="tc" value="1" /> <small>I am at least 18 years of age </small>
                </div>
               
             </div>
             <div class="form__section">
                <div class="form-elm form-elm--cb" >
                    <input bind:checked={hasAcceptedTC} type="checkbox" id="tc" value="1" /> <small>Please check this box to agree to our <a on:click|preventDefault={showTerms} class="terms" href="/terms">terms and conditions</a></small>
                </div>
                <div class="form-elm" style="padding-left:0">
                    <button disabled='{ !hasAcceptedTC || !hasAcceptedAgeGate }' on:click|preventDefault={doLogin}>Go</button>
                </div>
             </div>
        </form>
        <a class="contact"  href="https://pages.southernco-op.co.uk/membership/join-us?utm_source=Member-app&utm_medium=Home-screen-text&utm_id=Membership-sign-up-app">Not a member? Register today.</a>

        <p>Already a member but having problems? View our app <a style="text-decoration: underline" href="https://southern.coop/membership/members-app/membership-app-faqs" target="_blank">FAQS</a></p>
        
        

    </div>
</section>


